// The 3D figures (three.js) and written guides are only needed on an exercise's page, so they
// load as a separate chunk (and are cached by the service worker for offline).
import type { Figure3 } from '../figures3d/render.ts';

export type Guide = { summary: string; setup: string[]; steps: string[]; cues: string[]; safety: string[] };
export type Figure3D = Figure3;
export type Figures3D = typeof import('../figures3d/render.ts');
export type ExerciseContent = { figures: Record<string, Figure3D>; lib: Figures3D; guides: Record<string, Guide> };

let loading: Promise<ExerciseContent> | null = null;

export function loadExerciseContent(): Promise<ExerciseContent> {
  loading ??= Promise.all([import('../figures3d/library/index.ts'), import('../figures3d/render.ts'), import('./guides.json')]).then(([figs, lib, guides]) => ({
    figures: figs.FIGURES3D,
    lib,
    guides: guides.default as Record<string, Guide>,
  }));
  // A failed load (offline before it was ever cached) can be retried on the next visit.
  loading.catch(() => (loading = null));
  return loading;
}
